import { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import TableFilter from "../../../components/TableFilter";
import EmptyData from "../../../components/EmptyData";
import UserAvatar from "../../../components/UserAvatar";
import PaginationComponent from "../../../components/Pagination";
import Badge from "../../../components/Badge";
import InfoItem from "../../../helpers/InfoItem/InfoItem";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { Col, Modal, ModalBody, ModalHeader, Row } from "react-bootstrap";
import { InvoiceDetails } from "../InvoicesUser/InvoicesUser";
import { renewalUserContext } from "../../../context/UserContext/RenewalUserContext/RenewalUserContext";
import { convertDate } from "../../../utils";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import {
  convertInvoiceStatusToColor,
  convertInvoiceStatusToText,
  convertProductTypeToText,
  convertRoleToPath,
} from "../../../utils/enum";
import { OrderDetails } from "../OrdersUser/OrdersUser";

const RenewalsUser = () => {
  const { user, order, invoice } = useParams();

  const auth = useSelector((state) => state.auth);

  const {
    renewals,
    renewal,
    setRenewal,
    sort,
    setSort,
    invoiceStatus,
    setInvoiceStatus,
    start,
    setStart,
    end,
    setEnd,
    pageCount,
    pageNumber,
    setPageNumber,
    itemsCount,
    setItemsCount,
    handleGetRenewals,
    handleDeleteRenewal,
  } = useContext(renewalUserContext);

  useEffect(() => {
    handleGetRenewals();
  }, [
    start,
    end,
    pageNumber,
    invoiceStatus,
    itemsCount,
    sort,
    user,
    order,
    invoice,
  ]);

  return (
    <>
      <SiteTitle title="تمدیدها" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        setStart={setStart}
        start={start}
        setEnd={setEnd}
        end={end}
        invoiceStatus={invoiceStatus}
        setInvoiceStatus={setInvoiceStatus}
      />

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          {isEmpty(renewals) ? (
            <EmptyData />
          ) : (
            <>
              <div className="table-responsive scroll-sm">
                <table className="table bordered-table sm-table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">محصول</th>
                      <th scope="col">کاربر</th>
                      <th scope="col">شماره همراه</th>
                      <th scope="col">
                        مبلغ <Currency />
                      </th>
                      <th scope="col">کدپیگیری</th>
                      <th scope="col">نوع محصول</th>
                      <th scope="col">تاریخ ثبت</th>
                      <th scope="col">وضعیت فاکتور</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {renewals.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <Link
                            to={`/${convertRoleToPath(auth.role)}/product/${
                              item?.renewalOrder?.product?.original
                            }/product`}
                          >
                            <div className="d-flex align-items-center">
                              <UserAvatar
                                className="ms-2"
                                {...(item?.renewalOrder?.product?.picture
                                  ? {
                                      image:
                                        item?.renewalOrder?.product?.picture,
                                    }
                                  : {
                                      icon: "solar:box-broken",
                                    })}
                              />
                              <div className="flex-grow-1">
                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                  {item?.renewalOrder?.product?.title}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <UserAvatar
                              className="ms-2"
                              {...(item?.user?.avatar
                                ? { image: item?.user?.avatar }
                                : {
                                    icon: "solar:renewal-broken",
                                  })}
                            />
                            <div className="flex-grow-1">
                              <span className="text-md mb-0 fw-normal text-secondary-light">
                                {item?.user?.firstName} {item?.user?.lastName}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>{item?.user?.phoneNumber}</td>
                        <td>
                          <ConvertCurrency
                            price={item?.invoice?.amount}
                            pending
                          />
                        </td>
                        <td>{item?.renewalOrder?.trackingCode}</td>
                        <td>
                          {convertProductTypeToText(
                            item?.renewalOrder?.product?.type
                          )}
                        </td>
                        <td>
                          {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm")}
                        </td>
                        <td>
                          <Badge
                            color={convertInvoiceStatusToColor(
                              item?.invoice?.status
                            )}
                          >
                            {convertInvoiceStatusToText(item?.invoice?.status)}
                          </Badge>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="hover-bg-transparent"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <Icon
                                icon="ph:dots-three-outline-fill"
                                className="menu-icon"
                              />
                            </button>
                            <ul className="dropdown-menu list">
                              <li
                                onClick={() => setRenewal(item)}
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer"
                              >
                                جزئیات
                              </li>
                              {auth.isAdmin && (
                                <>
                                  <li className="dropdown-divider" />

                                  <li
                                    onClick={() =>
                                      areYouSureMessage(
                                        () => handleDeleteRenewal(item._id),
                                        `آیا از حذف تمدید ${item?.user?.firstName} ${item?.user?.lastName} مطمئنید؟`
                                      )
                                    }
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer text-danger"
                                  >
                                    حذف
                                  </li>
                                </>
                              )}
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            </>
          )}
        </div>
      </div>

      <Modal
        show={!isEmpty(renewal) && !renewal.isStatus}
        className="modal-dialog-centered"
        size="lg"
        onHide={() => setRenewal({})}
      >
        <ModalHeader closeButton>
          <span className="fs-5 fw-bold">جزئیات عملیات</span>
        </ModalHeader>
        <ModalBody>
          {auth.isAdmin && (
            <>
              <span className="text-primary brenewal-bottom fw-bold">
                اطلاعات کاربر
              </span>
              <Row className="g-2">
                <Col sm="6">
                  <InfoItem title="نام">{renewal?.user?.firstName}</InfoItem>
                </Col>
                <Col sm="6">
                  <InfoItem title="نام خانوادگی">
                    {renewal?.user?.lastName}
                  </InfoItem>
                </Col>
                <Col sm="6">
                  <InfoItem title="شماره همراه">
                    {renewal?.user?.phoneNumber}
                  </InfoItem>
                </Col>
                <Col sm="6">
                  <InfoItem title="پست الکترونیک">
                    {renewal?.user?.email}
                  </InfoItem>
                </Col>
              </Row>
            </>
          )}
          <span className="text-primary brenewal-bottom fw-bold">
            اطلاعات تمدید
          </span>
          <Row className="g-2">
            <Col sm="6">
              <InfoItem title="تاریخ ایجاد">
                {convertDate(renewal.createdAt, "YYYY/MM/DD - HH:mm")}
              </InfoItem>
            </Col>
            <Col sm="6">
              <InfoItem title="تاریخ آخرین ویرایش">
                {convertDate(renewal.updatedAt, "YYYY/MM/DD - HH:mm")}
              </InfoItem>
            </Col>
          </Row>

          <div className="card radius-12 my-3 border">
            <div className="card-header py-16 px-24 bg-base d-flex align-items-center gap-1 justify-content-between border border-end-0 border-start-0 border-top-0">
              <div>
                <h6 className="text-lg mb-0">سفارش قبل</h6>
              </div>
            </div>
            <div className="card-body py-16 px-24">
              <OrderDetails order={renewal?.order} />
            </div>
          </div>
          <div className="card radius-12 my-3 border">
            <div className="card-header py-16 px-24 bg-base d-flex align-items-center gap-1 justify-content-between border border-end-0 border-start-0 border-top-0">
              <div>
                <h6 className="text-lg mb-0">سفارش تمدید شده</h6>
              </div>
            </div>
            <div className="card-body py-16 px-24">
              <OrderDetails order={renewal?.renewalOrder} />
            </div>
          </div>

          <InvoiceDetails invoice={renewal?.invoice} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default RenewalsUser;
